exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".o-dashresults ul {\n  max-width: 60%;\n  display: flex;\n  justify-content: space-between; }\n  @media (max-width: 680px) {\n    .o-dashresults ul {\n      flex-direction: column; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/stylesheets/components/dashresults.scss
// module id = 56
// module chunks = 0